import { EnrollmentTag } from '@zorro/clients';
import { Badge, BadgeVariant } from '@zorro/design-system/v2/Badge';

import { enrollmentTagConfig } from './enrollmentTagConfig';

type Props = {
  tag: EnrollmentTag;
  variant?: BadgeVariant;
};

export const EnrollmentTagBadge = ({ tag, variant = 'simple' }: Props) => {
  const { label, color, icon } = enrollmentTagConfig[tag];

  return (
    <Badge color={color} leftSection={icon} variant={variant}>
      {label}
    </Badge>
  );
};
